import { render } from "./Whoweare.vue?vue&type=template&id=a2e4131a&scoped=true"
import script from "./Whoweare.vue?vue&type=script&lang=js"
export * from "./Whoweare.vue?vue&type=script&lang=js"

import "./Whoweare.vue?vue&type=style&index=0&id=a2e4131a&scoped=true&lang=css"

import exportComponent from "/builds/appmart-development-team/appmart-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2e4131a"]])

export default __exports__